import type { StoreProductPrice } from '@gozoki/api-types'
import { useQuery } from '@tanstack/react-query'
import { gozokiApiWithAuth } from '../gozokiApi'

export const updateStoreProductPrice = async (
  storeId: number,
  productId: string,
  pricing: {
    sellPrice?: number
    franco?: number
    coldStartStockMin?: number
    agPromo?: number
  },
): Promise<StoreProductPrice> => {
  const response = await gozokiApiWithAuth.post<{ data: StoreProductPrice }>(
    `/stores/${storeId}/products/${productId}/price`,
    pricing,
  )
  return response.data.data
}

export const fetchStoreProductPrices = async (storeId: number): Promise<StoreProductPrice[]> => {
  const response = await gozokiApiWithAuth.get<{ data: StoreProductPrice[] }>(
    `/stores/${storeId}/prices`,
  )
  return response.data.data || []
}

export const useStoreProductPrices = (storeId: number) =>
  useQuery({
    queryKey: ['storeProductPrices', storeId],
    queryFn: () => fetchStoreProductPrices(storeId),
    enabled: !!storeId,
  })
